import Vue from 'vue'
import VueX from 'vuex'
import { mState, mMutations, mActions, mGetters } from './store.js'
Vue.use(VueX)

const debug = process.env.NODE_ENV !== 'production'
const state = mState
// 同步
const mutations = mMutations
// 异步
const actions = mActions
// 计算
const getters = mGetters

export default new VueX.Store({
  debug, state, mutations, actions, getters
})



// WEBPACK FOOTER //
// ./src/vuex/index.js